import React, { useEffect, useRef } from "react";
import Shepherd from "shepherd.js";
import { useStore } from "../store/store";

const ShepherdTour: React.FC<{ isOpen: boolean; onClose: () => void }> = ({
  isOpen,
  onClose,
}) => {
  const { isTourOpen, setTourOpen } = useStore();
  const tourRef = useRef<Shepherd.Tour | null>(null);

  useEffect(() => {
    if (!tourRef.current) {
      tourRef.current = new Shepherd.Tour({
        defaultStepOptions: {
          classes: "backdrop--blur outline-none",
          scrollTo: true,
        },
        useModalOverlay: false,
      });

      // Handle tour events
      ["close", "cancel", "complete"].forEach((event) => {
        tourRef.current!.on(event, () => {
          setTourOpen(false);
          onClose();
        });
      });

      // Define tour steps
      tourRef.current.addStep({
        id: "stepCollection",
        arrow: false,
        text: `
        <h1>DE COLLECTIE</h1>
        <p>
          Scrol hier door de collectie van Museum Arnhem en laat je inspireren.
        </p>
        <span class="d-icon d-scroll text-white"></span>
        `,
        classes: "shepherd-step-centered",
        buttons: [
          {
            text: "Volgende",
            action: tourRef.current.next,
          },
          {
            text: `<span class="d-icon flex d-close"></span>`,
            action: tourRef.current.cancel,
            classes: `shepherd-close backdrop`,
          },
        ],
      });

      tourRef.current.addStep({
        id: "stepSearch",
        arrow: true,
        text: `
            <h1>ZOEKEN</h1>
            <p>
              Zoek hier naar kunstenaars of kunstwerken.
            </p>
            <span class="d-icon d-search-field text-white"></span>
          `,
        attachTo: {
          element: ".button-search",
          on: "left-start",
        },
        buttons: [
          {
            text: "Volgende",
            action: tourRef.current.next,
          },
        ],
      });

      tourRef.current.addStep({
        id: "stepHistory",
        arrow: true,
        text: `
          <h1>GESCHIEDENIS EN CONNECTIES MAKEN</h1>
          <p>
            Kijk hier naar alle werken die je al hebt bekeken en mail dit overzicht naar jezelf of maak hier je eigen connectie.
          </p>
          <span class="d-icon d-pencil text-white"></span>
        `,
        attachTo: {
          element: ".button-history",
          on: "left-start",
        },
        buttons: [
          {
            text: "Volgende",
            action: tourRef.current.next,
          },
        ],
      });

      tourRef.current.addStep({
        id: "stepFiltering",
        arrow: true,
        text: `
                  <h1>SORTEREN</h1>
                  <p>
                    Sorteer de collectie hier op jaartal of op verschillende categorieën.
                  </p>
                  <span class="d-icon d-menu-dialpad text-white"></span>
                  <span class="d-icon d-menu-dialpad text-white"></span>
                  <span class="d-icon d-menu-dialpad text-white"></span>
                `,
        attachTo: {
          element: ".button-sorting",
          on: "left-start",
        },
        buttons: [
          {
            text: "Volgende",
            action: tourRef.current.next,
          },
        ],
      });
    }

    if (isOpen) {
      tourRef.current.start();
    } else {
      if (tourRef.current && tourRef.current.isActive()) {
        tourRef.current.cancel();
      }
    }
  }, [isOpen, setTourOpen, onClose]);

  return null; // This component doesn't render anything
};

export default ShepherdTour;
